document.addEventListener("rebuy:cart.change", () => {
  const $smartCart = document.querySelector("#rebuy-cart");
  if (!$smartCart) return;
  const $moneySelectors = $smartCart.querySelectorAll(".money");
  $moneySelectors.forEach(($element) => $element.classList.remove("done"));
});

document.addEventListener("rebuy:smartcart.ready", () => {
  const $smartCart = document.querySelector("#rebuy-cart");
  const observer = new MutationObserver((mutationList, observer) => {
    for (const mutation of mutationList) {
      if (mutation.target.classList.contains("rebuy-cart__flyout-discount-container")) {
        const $moneySelectors = $smartCart.querySelectorAll(".money");
        $moneySelectors.forEach(($element) => $element.classList.remove("done"));
      }
    }
  });
  
  // Start observing the target node for configured mutations
  observer.observe($smartCart, { childList: true, subtree: true });
});

